import { assertTruthy } from '../assertsF/assertTruthyAI.mts';
export const sha256Browser = async (str) => {
    assertTruthy(crypto?.subtle, { crypto });
    const msgBuffer = new TextEncoder().encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
